import { CloseOutlined } from '@ant-design/icons'
import { Modal, Space } from 'antd'
import {useState, } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import LandedCostsByPurchase from './landedCosts'
import PaymentsByPurchaseModal from './paymentsByPurchase'
import PurchaseIncomingModal from './purchaseIncoming'
import ViewPurchaseIncomingModal from './view'

const ViewSalesModal = ({
	visible,
	data,
	onClose,
	incoming = false,
	finishSale = false,
	ship = false,
	changeStatus = false,
	showPayment = false,
	isShowIncomingTab = true,
	isShowPaymentTab=false,
	isShowLandedCosts = false,
	isShowPriceAtWhs = false,
	refetch,
	isShowDocRate = false,
}) => {

	const renderContent = () => {
		switch (activeTab) {
			case 'tab1':
				return (
					<ViewPurchaseIncomingModal
						data={data}
						finishSale={finishSale}
						ship={ship}
						incoming={incoming}
						changeStatus={changeStatus}
						showPayment={showPayment}
						refetch={refetch}
						isShowLandedCosts={isShowLandedCosts}
						isShowPriceAtWhs={isShowPriceAtWhs}
						onClose={onCloseModal}
						isShowDocRate={isShowDocRate}
					/>
				)
			case 'tab2':
				return (
					<PurchaseIncomingModal
						data={data}
						finishSale={finishSale}
						ship={ship}
						incoming={incoming}
						changeStatus={changeStatus}
						showPayment={showPayment}
						refetch={refetch}
						onClose={onCloseModal}
						isShowLandedCostTab
						isShowLandedCosts={isShowLandedCosts}
					/>
				)
			case 'tab3':
				return (
					<LandedCostsByPurchase
						data={data}
						finishSale={finishSale}
						ship={ship}
						incoming={incoming}
						changeStatus={changeStatus}
						showPayment={showPayment}
						refetch={refetch}
						onClose={onCloseModal}
					/>
				)
			case 'tab4':
				return (
					<PaymentsByPurchaseModal
						data={data}
					docEntry={data?.docEntry}
					/>
				)

			default:
				return null
		}
	}
	const { t } = useTranslation()

	const [activeTab, setActiveTab] = useState('tab1')

	const onCloseModal = () => {
		onClose()
		setActiveTab('tab1')
	}

	if (!data) return null

	return (
		<Modal
			title={
				<h1 className="font-nunito text-xl font-extrabold text-[#000000]">
					{t('order')} № {data?.docNumPrefix}
				</h1>
			}
			open={visible}
			onCancel={onCloseModal}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="90%"
		>
			<Space style={{ marginBottom: 16 }} className="mt-5">
				<button
					className={`${
						activeTab === 'tab1'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold `}
					onClick={() => setActiveTab('tab1')}
				>
					{t('detailed')}
				</button>
				{isShowIncomingTab && (
					<button
						className={`${
							activeTab === 'tab2'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold ml-3`}
						onClick={() => setActiveTab('tab2')}
					>
						{t('purchaseIncoming')}
					</button>
				)}
				{/* {isShowPaymentTab && (
					<button
						className={`${
							activeTab === 'tab4'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold ml-3`}
						onClick={() => setActiveTab('tab4')}
					>
						{t('payments')}
					</button>
				)} */}
			</Space>
			<div className="mt-5">{renderContent()}</div>
		</Modal>
	)
}

export default ViewSalesModal
